import { Component } from '@angular/core';

@Component({
  selector: 'ui-goo',
  imports: [],
  templateUrl: './goo.component.html',
  styleUrl: './goo.component.scss',
})
export class GooComponent {}
